import BlindsAndShuttersForm from './BlindsAndShuttersForm';

export default BlindsAndShuttersForm;